import { useMemo } from 'react';
import { useReactiveVar } from '@apollo/client';

import {
  CheckAnswerButtonWrapper,
  CheckAnswerSecondaryButton,
} from '../check-answer/check-answer.style';
import { checkAnswerVar } from '../check-answer/check-answer.apollo';
import {
  ActivityPresentAnswerButtonContainer,
  ActivityPresentAnswerButtonWrapper,
} from './activity-present-answer-button.style';

type Props = {
  sectionId: string;
};
const ActivityPresentAnswerButton = ({ sectionId }: Props) => {
  const checkAnswerData = useReactiveVar(checkAnswerVar);

  const hasAnsweredComponents = useMemo(() => {
    for (const item in checkAnswerData) {
      if (
        checkAnswerData[item]?.sectionId === sectionId &&
        checkAnswerData[item]?.hasChecked
      ) {
        return true;
      }
    }
    return false;
  }, [checkAnswerData, sectionId]);

  return hasAnsweredComponents ? (
    <ActivityPresentAnswerButtonWrapper>
      <ActivityPresentAnswerButtonContainer>
        <CheckAnswerButtonWrapper>
          <CheckAnswerSecondaryButton
            type="button"
            onClick={() => {
              const updatedAnswerData = {
                ...checkAnswerData,
              };
              for (const item in checkAnswerData) {
                const componentAnswer = checkAnswerData[item];
                if (
                  componentAnswer?.sectionId === sectionId &&
                  componentAnswer?.hasChecked
                ) {
                  updatedAnswerData[componentAnswer.id] = {
                    ...componentAnswer,
                    hasChecked: false,
                    hasReset: true,
                    answer: undefined,
                    multiAnswer: {
                      answerRefs: [],
                      correctRefs:
                        componentAnswer.multiAnswer?.correctRefs || [],
                      correctLabels:
                        componentAnswer.multiAnswer?.correctLabels || [],
                    },
                  };
                }
              }
              checkAnswerVar(updatedAnswerData);
            }}
          >
            Reset Selected Answers
          </CheckAnswerSecondaryButton>
        </CheckAnswerButtonWrapper>
      </ActivityPresentAnswerButtonContainer>
    </ActivityPresentAnswerButtonWrapper>
  ) : null;
};

export default ActivityPresentAnswerButton;
